module.exports = __webpack_public_path__ + "media/src/components/GenerateDocument/images/SS-error-vector-9c0a85a12ba5c97f97a73b6e81b3ab29.png";